import {AvField, AvForm} from "availity-reactstrap-validation";
import {Label} from "reactstrap";
import {FormattedMessage} from "react-intl";

import SubmitButton from "@components/buttons/submitButton";
import patterns from "@constants/patterns";

const CheckForm = ({loginValue, setLoginValue, handleCheckLogin, isLoading}) => {
    return (
        <AvForm onValidSubmit={handleCheckLogin}>
            <Label for="loginValue">
                <FormattedMessage id="mobileNumber"/>
            </Label>

            <AvField
                name="loginValue"
                id="loginValue"
                type='text'
                value={loginValue}
                onChange={(e) => setLoginValue(e.target.value)}
                validate={{
                    required: {value: true, errorMessage: 'الزامی می باشد.'},
                    pattern: patterns.emailOrMobile
                }}
            />

            <SubmitButton className="w-100" isLoading={isLoading}>
                <FormattedMessage id="check"/>
            </SubmitButton>
        </AvForm>
    );
};

export default CheckForm;
